<template>
	<div class="page-container">
		<head-top head-title="重置密码" goBack="true"></head-top>

		<div class="forgot-page">
			<div class="forgot-title">重置密码</div>
			<div class="forgot-desc">请输入您的邮箱账号，我们将发送验证码到您的邮箱</div>

			<div class="forgot-body">
				<div class="step1" v-if="!showStep2">
					<div class="input-group">
						<input class="input-field" v-model="forgotEmail" placeholder="请输入邮箱账号" type="text" />
					</div>
					<div class="submit-btn" @click="sendForgotCode">获取验证码</div>
				</div>

				<div class="step2" v-if="showStep2">
					<div class="input-group">
						<input class="input-field" v-model="forgotCode" placeholder="请输入邮箱验证码" type="text" />
					</div>
					<div class="input-group">
						<input class="input-field" v-model="newPassword" placeholder="请输入新密码" type="password" />
					</div>
					<div class="input-group">
						<input class="input-field" v-model="confirmPassword" placeholder="请重复新密码" type="password" />
					</div>
					<div class="submit-btn" @click="resetPassword">保存</div>
					<div class="back-btn" @click="goBack">返回上一步</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import headTop from '@/components/common/head.vue'
	import { getFindPasswordEmailValidCode, resetPassword, logoutMember } from '@/apis/api.js'

	export default {
		name: 'ForgotPassword',
		components: {
			headTop
		},
		data() {
			return {
				forgotEmail: '',
				forgotCode: '',
				newPassword: '',
				confirmPassword: '',
				showStep2: false
			}
		},
		methods: {
			isEmail(email) {
				return /^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+$/.test(email)
			},
			sendForgotCode() {
				if (!this.isEmail(this.forgotEmail)) {
					this.$toast('请输入正确邮箱')
					return
				}
				this.$toast.loading({ message: '发送中...', duration: 0 })
				getFindPasswordEmailValidCode(this.forgotEmail)
					.then(() => {
						this.$toast.clear()
						this.$toast.success('验证码已发送')
						this.showStep2 = true
					})
					.catch(e => {
						this.$toast.clear()
						if (!e.handled) {
							this.$toast(e.msg || '发送失败')
						}
					})
			},
			resetPassword() {
				if (!this.forgotCode.trim()) {
					this.$toast('请输入邮箱验证码')
					return
				}
				if (!this.newPassword || this.newPassword.length < 6) {
					this.$toast('密码至少6位')
					return
				}
				if (this.newPassword !== this.confirmPassword) {
					this.$toast('两次密码不一致')
					return
				}
				this.$toast.loading({ message: '保存中...', duration: 0 })
				resetPassword({
					code: this.forgotCode,
					email: this.forgotEmail,
					pwd: this.newPassword
				})
					.then(() => {
						this.$toast.clear()
						this.$toast.success('密码重置成功')
						logoutMember()
						setTimeout(() => {
							this.$router.push('/login')
						}, 500)
					})
					.catch(e => {
						this.$toast.clear()
						if (!e.handled) {
							this.$toast(e.msg || '重置失败')
						}
					})
			},
			goBack() {
				this.showStep2 = false
				this.forgotCode = ''
				this.newPassword = ''
				this.confirmPassword = ''
			}
		}
	}
</script>

<style lang="scss" scoped>
	.page-container {
		padding-top: 48px;

		.forgot-page {
			padding: 50px 28px 0;

			.forgot-title {
				color: #222222;
				font-size: 24px;
				font-weight: bold;
			}

			.forgot-desc {
				margin-top: 10px;
				color: #888888;
				font-size: 14px;
			}

			.forgot-body {
				margin-top: 55px;

				.input-group {
					height: 46px;
					margin-bottom: 14px;
					border-bottom: 1px solid #e4e7ed;
					box-sizing: border-box;

					.input-field {
						width: 100%;
						height: 46px;
						line-height: 46px;
						color: #222222;
						font-size: 15px;

						&::placeholder {
							color: #999;
						}
					}
				}

				.submit-btn {
					cursor: pointer;
					height: 44px;
					line-height: 44px;
					text-align: center;
					margin-top: 30px;
					color: #ffffff;
					background: #e33737;
					border-radius: 22px;
					font-size: 17px;
					font-weight: bold;
					width: 100%;
				}

				.back-btn {
					cursor: pointer;
					height: 44px;
					line-height: 44px;
					text-align: center;
					margin-top: 30px;
					color: #e33737;
					background: #fff;
					border-radius: 22px;
					font-size: 17px;
					width: 100%;
					border: 1px solid #e33737;
				}
			}
		}
	}
</style>